var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 15.4165C10.6904 15.4165 11.2501 14.8569 11.2501 14.1665C11.2501 13.4761 10.6904 12.9165 10.0001 12.9165C9.30973 12.9165 8.75008 13.4761 8.75008 14.1665C8.75008 14.8569 9.30973 15.4165 10.0001 15.4165Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90207 2.84899C8.44356 2.36767 9.19692 2.08317 10.0001 2.08317C10.8032 2.08317 11.5566 2.36767 12.0981 2.84899C12.6364 3.32747 12.9167 3.95393 12.9167 4.58317C12.9167 5.04341 13.2898 5.4165 13.7501 5.4165C14.2103 5.4165 14.5834 5.04341 14.5834 4.58317C14.5834 3.4443 14.0736 2.37507 13.2054 1.60331C12.3403 0.834388 11.186 0.416504 10.0001 0.416504C8.81412 0.416504 7.65983 0.834388 6.79479 1.60331C5.92656 2.37507 5.41675 3.4443 5.41675 4.58317V7.91926C3.9471 7.98754 2.91675 9.31479 2.91675 10.7498V16.7498C2.91675 18.2233 4.00304 19.5832 5.5358 19.5832H14.4644C15.9971 19.5832 17.0834 18.2233 17.0834 16.7498V10.7498C17.0834 9.27634 15.9971 7.9165 14.4644 7.9165H7.08341V4.58317C7.08341 3.95393 7.36378 3.32747 7.90207 2.84899ZM5.5358 9.58317C5.0961 9.58317 4.58341 10.0142 4.58341 10.7498V16.7498C4.58341 17.4855 5.0961 17.9165 5.5358 17.9165H14.4644C14.9041 17.9165 15.4167 17.4855 15.4167 16.7498V10.7498C15.4167 10.0142 14.9041 9.58317 14.4644 9.58317H5.5358Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ff433cdc4a1f987ccef6870a43820c4d.svg";
export { ForwardRef as ReactComponent };